document.querySelectorAll('[data-kontaktai]').forEach((section) => {
    section.querySelectorAll('[data-copy]').forEach((button) => {
        button.addEventListener('click', async () => {
            const value = button.getAttribute('data-copy') || '';
            if (!value) {
                return;
            }

            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(value);
                } else {
                    const input = document.createElement('input');
                    input.value = value;
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    input.remove();
                }

                button.classList.add('is-copied');
                window.setTimeout(() => button.classList.remove('is-copied'), 1200);
            } catch (error) {
                // Silent fail — user can still select/copy manually.
            }
        });
    });
});
